import React from "react";
import { useStore } from "./flow/store";

const audio = new Audio();

export default function Music({ url }) {
  const musicPlaying = useStore((state) => state.musicPlaying);

  React.useEffect(() => {
    if (audio === null) return;
    audio.currentTime = 0;
    audio.loop = true;
    audio.muted = !musicPlaying;
  }, [musicPlaying]);

  React.useEffect(() => {
    function onInteraction() {
      audio.src = url;
      audio.muted = true;
      audio.autoplay = true;
    }

    window.addEventListener("click", onInteraction);
    return () => {
      window.removeEventListener("click", onInteraction);
    };
  }, [url]);

  return null;
}
